import * as Sentry from "@sentry/react";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { SiteStoryStage } from "../SiteStoryStage";

/**
 * Keeps a crashing story on the public pages from taking the whole page down: the error is reported, and the story
 * is replaced by its background with "Not loaded" in the middle
 */
export const SiteStoryBoundary = ({ children }) => {
    return (
        <ErrorBoundary fallback={<SiteStoryStage notLoaded />} onError={(error) => Sentry.captureException(error)}>
            {children}
        </ErrorBoundary>
    );
};
